import React from "react";
import { useLocation } from "react-router-dom";
import GenericCard from "@ui-components/Card/GenericCard";
import PaidLicenses from "../Licensing/PaidLicenses/PaidLicenses";
import PAYG from "../Licensing/PAYG/PAYG";
import LicenseModal from "../Licensing/LicenseModal/LicenseModal";
import { trimTrailingSlash } from "@shared/helpers/pathname";

const LicensingPage: React.FC = () => {
  const location = useLocation();
  const [isLicenseModalOpen, setIsLicenseModalOpen] = React.useState(false);

  const path = trimTrailingSlash(location.pathname);

  // Determine which component to render based on the current path (trim trailing slash)
  const isPaidLicenses =
    path === "/reflector-v2/management/licensing" ||
    path === "/reflector-v2/admin-center/management/licensing";
  //const isRegularLicensing = location.pathname === "/reflector-v2/management/licensing";

  return (
    <div className="relative">
      {/* `flex` in the className opts the card body out of GenericCard's default
          `max-h-[1000px]` cap (GenericCard.tsx:205) — the licenses table is now
          viewport-sized (CTX-244), so on a tall window that cap would end the card's
          border box above the last rows. */}
      <GenericCard isCollapsible={false} className="flex flex-col">
        {/* Card Header: Title, Add Button */}
        {/* {isRegularLicensing && (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 p-4 border-b border-gray-100">
            <div className="flex w-full justify-end">
              <GenericButton
                label="Add/Buy License"
                variant="brand"
                size="md"
                onClick={() => setIsLicenseModalOpen(true)}
              />
            </div>
          </div>
        )} */}
        {/* Card Body: Tab Content */}
        <div>
          {isPaidLicenses ? (
            <PaidLicenses />
          ) : (
            <PAYG />
          )}
        </div>
      </GenericCard>
      {/* License Modal */}
      <LicenseModal
        isOpen={isLicenseModalOpen}
        onClose={() => setIsLicenseModalOpen(false)}
      />
    </div>
  );
};

export default LicensingPage; 